<template>
  <div class="provider-chip">
    <span>{{ provider.name }}</span>
    <i class="las la-times" @click="removeFilter"></i>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const router = useRouter()

const selectedManufacturersSlugs = computed(() => (route.query.manufacturer ? route.query.manufacturer.split(',') : []))

function removeFilter() {
  if (selectedManufacturersSlugs.value.length > 1) {
    const manufacturer = selectedManufacturersSlugs.value
      .filter((el) => el.toLowerCase() !== props.provider.code.toLowerCase())
      .map((el) => el)
      .join(',')

    router.push({ query: { manufacturer } }).catch(() => {})
    return
  }

  const query = { ...route.query }
  delete query.manufacturer
  router.push({ query })
}
</script>

<style scoped lang="scss">
.provider-chip {
  font-size: 14px;
  color: var(--cas-secondary);
  display: flex;
  align-items: center;
  line-height: 1;
  height: 35px;
  padding: 10px 12px;
  border: 1px solid #898989;
  border-radius: var(--radius-1);

  i {
    font-size: 20px;
    color: #bdbebc;
    margin-left: 5px;
    margin-right: -3px;

    &:hover {
      cursor: pointer;
      color: #e8e8e8;
      transition: 0.3s;
    }
  }
}
</style>
